import LocalUrlMaker from "../../lib/LocalUrlMaker";
import {isEmpty} from "lodash";
import {paramsToQueryString} from "../../lib/params";

/**
 * Build the path to the checkout, like /new_checkout/KWYJIBO
 *
 * @param cart
 * @param cartCode
 * @param action
 * @param format
 * @param params
 * @returns {*}
 */
export function getCheckoutPath({
  cart, cartCode, action, format = 'html',
  params = {}
}) {
  cartCode ||= cart?.cartCode || cart?.cart_code; // underscore ok

  if (!cartCode) {
    console.error("cannot determine cart code from cart: ", cart)
    return;
  }

  let path = `/new_checkout/${cartCode}`;
  if (action)
    path += `/${action}`;

  if (format && (format !== 'html'))
    path += `.${format}`

  if (!isEmpty(params)) {
    path = `${path}?${paramsToQueryString(params)}`
  }

  return LocalUrlMaker.prefixedPath(path);
}
